import {
  FETCH_ACCOUNT_LIST_SUCCESS,
  FETCH_ACCOUNT_LIST_FAILED,
  SET_SELECTED_ACCOUNT_ID,
  GET_SAVING_ACCOUNT_ID,
  GET_SELECTED_ACCOUNT_DETAILS_SUCCESS,
  GET_SELECTED_ACCOUNT_DETAILS_FAILURE,
  GET_SELECTED_ACCOUNT_DETAILS,
} from '../../constants/actionTypes';
import { fromJS } from 'immutable';
import { ifOverdraftAvailable } from '../../../src/utils/AccountDetailsBuilder';

export const initialState = fromJS({
  isFetched: false,
  accountList: {},
  selectedAccountId: '',
  savingAccountID: '',
  isAccountListError: false,
  ifOverdraftAvailable: false,
  isAccountDetailFetched: false,
  isAccountDetailsError: false,
});

const accountList = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_ACCOUNT_ID:
      return state.set('selectedAccountId', action.payload);
    case FETCH_ACCOUNT_LIST_SUCCESS:
      return state.set('accountList', action.payload).set('isFetched', true);
    case FETCH_ACCOUNT_LIST_FAILED:
      return state.set('isFetched', true).set('isAccountListError', true);
    case GET_SAVING_ACCOUNT_ID:
      return state.set('savingAccountID', action.savingAccountID);
    case GET_SELECTED_ACCOUNT_DETAILS:
      return state.set('isAccountDetailFetched', fromJS(false));
    case GET_SELECTED_ACCOUNT_DETAILS_SUCCESS:
      return state
        .set('ifOverdraftAvailable', fromJS(ifOverdraftAvailable(action.payload)))
        .set('isAccountDetailFetched', fromJS(true));
    case GET_SELECTED_ACCOUNT_DETAILS_FAILURE:
      return state
        .set('isAccountDetailFetched', fromJS(true))
        .set('isAccountDetailsError', fromJS(true));
    default:
      return state;
  }
};

export default accountList;
